import { ContactDetailPage } from '@/pages/ContactDetailPage';
import type { PanelViewParams } from '../registry';

/**
 * Panel-Adapter: rendert die bestehende Kontakt-Detail-Seite embedded —
 * volle Funktionalität (Bearbeiten, Löschen, Bauvorhaben-Liste) statt
 * einer zweiten, schwächeren Kompakt-Ansicht. Löschen im Panel schließt
 * den Tab (onClose), Bearbeiten bleibt in der Leiste.
 */
export function ContactPanelView({ params, close }: { params: PanelViewParams; close: () => void }) {
  const id = Number(params.id);
  if (!Number.isFinite(id) || id <= 0) {
    return (
      <div className="card p-8 text-center text-gray-500">
        <p>Ungültiger Kontakt.</p>
      </div>
    );
  }
  return <ContactDetailPage contactId={String(id)} embedded onClose={close} />;
}